module.exports = __webpack_public_path__ + "img/electron_login_bg_2.6d47c4ff.png";